import React from "react";
import ServicesCard from "../cards/ServicesCard";

//  Style \\
import "../../assets/styles/sections/serviceSection.scss";

//  Datas \\

import serviceData from "../../assets/database/service.json";

const ServicesSection = () => {
  const data = serviceData.slice(0, 6);

  return (
    <section className="servicesSection">
      <div className="container">
        <div className="servicesSection_items">
          <div className="servicesSection_items_cardBox">
            {data.map((data, index) => (
              <ServicesCard key={data.id} data={data} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
